<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/projectmanagement/visitindex">Visit Reporting</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        {{ report.report_batch_code || "View Visit Report" }}
      </h6>

      <div class="container-fluid">
        <div class="card custom_bdr_rds shadow p-2" v-if="loading">
          <div class="card-body custom_bdr_rds">
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="mt-1" style="padding-bottom: 100px">
          <div class="card custom_bdr_rds shadow p-2 mb-3">
            <div class="card-body custom_bdr_rds">
              <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                <tbody>
                  <tr>
                    <td class="width-custom2"><b>Report Code</b></td>
                    <td>{{ report.report_batch_code || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Project</b></td>
                    <td>{{ report.project_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Patient</b></td>
                    <td>{{ report.patient_code || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Site</b></td>
                    <td>{{ report.site || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Screening Date</b></td>
                    <td>{{ formatDate(report.screening_date) }}</td>
                  </tr>
                  <tr>
                    <td><b>Investigators</b></td>
                    <td>{{ formatInvestigators(report.investigator_names) }}</td>
                  </tr>
                  <tr>
                    <td><b>Created Date</b></td>
                    <td>{{ report.created_date || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Created By</b></td>
                    <td>{{ report.created_by || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card custom_bdr_rds shadow p-2 mb-3">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-2"><b>Visit Schedule</b></h6>
              <div class="table-responsive">
                <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                  <thead class="background_color2">
                    <tr class="custom-label2">
                      <th style="width: 6%;">#</th>
                      <th style="width: 16%;">Treatment Phase</th>
                      <th style="width: 28%;">Description</th>
                      <th style="width: 12%;">Date</th>
                      <th style="width: 12%;">Allowed Deviation +/- Days</th>
                      <th style="width: 12%;">Visit Date</th>
                      <th style="width: 7%;">SAE</th>
                      <th style="width: 7%;">PD</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in report.visits" :key="row.id || index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ formatTreatmentPhase(row) }}</td>
                      <td>{{ row.description || "-" }}</td>
                      <td>{{ formatDate(row.date) }}</td>
                      <td>{{ formatDeviation(row.allowed_deviation_days) }}</td>
                      <td>{{ formatDate(row.visit_date) }}</td>
                      <td>{{ row.sae_count || 0 }}</td>
                      <td>{{ row.rpd_count || 0 }}</td>
                    </tr>
                    <tr v-if="!report.visits.length">
                      <td colspan="8" class="text-center text-muted">No visit schedule found.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            v-for="(row, index) in report.visits"
            :key="'details-' + (row.id || index)"
            class="card custom_bdr_rds shadow p-2 mb-3"
          >
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-2">
                <b>Visit {{ index + 1 }}: {{ formatTreatmentPhase(row) }}</b>
              </h6>

              <div v-if="row.sae_entries && row.sae_entries.length" class="mb-3">
                <h6 class="mb-2"><b>SAE Tracker</b></h6>
                <div class="table-responsive">
                  <table style="font-size: small;" class="table table-hover table-sm table-bordered">
                    <thead class="background_color2">
                      <tr class="custom-label2">
                        <th>Date of Awareness</th>
                        <th>SAE Serial Number</th>
                        <th>Patient Number</th>
                        <th>Event Term</th>
                        <th>Start Date</th>
                        <th>End date</th>
                        <th>Status</th>
                        <th>Report Date Initial</th>
                        <th>Report Date Follow-up</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(entry, entryIndex) in row.sae_entries" :key="'sae-' + entryIndex">
                        <td>{{ formatDate(entry.date_of_awareness) }}</td>
                        <td>{{ entry.sae_serial_number || "-" }}</td>
                        <td>{{ entry.patient_number || "-" }}</td>
                        <td>{{ entry.event_term || "-" }}</td>
                        <td>{{ formatDate(entry.start_date) }}</td>
                        <td>{{ formatDate(entry.end_date) }}</td>
                        <td>{{ entry.status || "-" }}</td>
                        <td>{{ formatDate(entry.report_date_initial) }}</td>
                        <td>{{ formatDate(entry.report_date_follow_up) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="row.rpd_entries && row.rpd_entries.length">
                <h6 class="mb-2"><b>PD Tracker</b></h6>
                <div class="table-responsive">
                  <table style="font-size: small;" class="table table-hover table-sm table-bordered">
                    <thead class="background_color2">
                      <tr class="custom-label2">
                        <th>PD Identified Date</th>
                        <th>Date of Occurrence</th>
                        <th>Subject No</th>
                        <th>Description of Protocol Deviation</th>
                        <th>Corrective/ Preventive Action Taken</th>
                        <th>Status</th>
                        <th>Reference number</th>
                        <th>No of similar events</th>
                        <th>Status of submission</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(entry, entryIndex) in row.rpd_entries" :key="'rpd-' + entryIndex">
                        <td>{{ formatDate(entry.pd_identified_date) }}</td>
                        <td>{{ formatDate(entry.date_of_occurrence) }}</td>
                        <td>{{ entry.subject_no || "-" }}</td>
                        <td>{{ entry.protocol_deviation_description || "-" }}</td>
                        <td>{{ entry.corrective_action_taken || "-" }}</td>
                        <td>{{ entry.status || "-" }}</td>
                        <td>{{ entry.reference_number || "-" }}</td>
                        <td>{{ entry.similar_events_count || "-" }}</td>
                        <td>{{ entry.submission_status || "-" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="!(row.sae_entries && row.sae_entries.length) && !(row.rpd_entries && row.rpd_entries.length)" class="text-muted">
                No tracker entries saved for this visit.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: {
    ContentFooter,
    TopNavbar,
  },

  data() {
    return {
      access_token: authService.isLoggedIn(),
      code: this.$route.query.code || "",
      loading: false,
      report: {
        visits: [],
      },
    };
  },

  mounted() {
    this.loadReport();
  },

  methods: {
    formatDate(value) {
      if (!value) {
        return "-";
      }

      const [year, month, day] = String(value).split("-");
      return year && month && day ? `${day}/${month}/${year}` : value;
    },

    formatDeviation(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "-";
      }

      const normalized = String(value).trim();

      if (!normalized) {
        return "-";
      }

      if (normalized === "0" || normalized === "+0" || normalized === "-0" || normalized === "+/- 0") {
        return "-";
      }

      if (normalized.startsWith("+") || normalized.startsWith("-")) {
        return normalized;
      }

      const parsed = parseInt(normalized, 10);
      if (Number.isNaN(parsed)) {
        return normalized;
      }

      return parsed > 0 ? `+${parsed}` : String(parsed);
    },

    formatTreatmentPhase(row) {
      if (row && row.treatment_phase_label) {
        return row.treatment_phase_label;
      }

      if (row && row.treatment_phase !== null && row.treatment_phase !== "") {
        return row.treatment_phase;
      }

      // Older visit records did not persist the numeric treatment phase.
      if (row && !row.is_fixed_row && row.visit_number) {
        return row.visit_number;
      }

      return "-";
    },

    formatInvestigators(value) {
      if (!Array.isArray(value) || !value.length) {
        return "-";
      }

      const names = value
        .map((item) => String(item || "").trim())
        .filter((item) => item !== "");

      return names.length ? names.join(", ") : "-";
    },

    async loadReport() {
      if (!this.code) {
        return;
      }

      this.loading = true;

      try {
        const { data } = await axios.get("/projectvisit/view?code=" + encodeURIComponent(this.code), {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200) {
          this.report = data.data || this.report;
        } else {
          alert(data.message || "Error loading visit report.");
        }
      } catch (error) {
        console.error(error.response || error);
        alert("Error loading visit report.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
